module.exports = __webpack_public_path__ + "static/media/FTR 1200 S.1cbed7e5.glb";